import styled from 'styled-components/macro';
import { fontSize, colour, lineHeight } from '@notonthehighstreet/toolkit/utils';
import { mediaQuery } from '../../styles/utils';

export const Container = styled.div`
  display: flex;
`;

export const PrivacyPolicyLink = styled.a({
  color: colour('venice-blue'),
  fontWeight: 'bold',
  textDecoration: 'none',
});

export const Blurb = styled.p({
  color: colour('emperor'),
  fontSize: fontSize('s'),
  lineHeight: lineHeight('l'),
});

export const FormContainer = styled.form(
  {
    position: 'relative',
  },
  props => {
    if (props.waitingForResponse) {
      return {
        opacity: '0.45',
        cursor: 'not-allowed',
      };
    }
    return null;
  }
);

export const JustifyContent = styled.div({
  display: 'block',
  [mediaQuery('tablet')]: {
    display: 'flex',
    justifyContent: 'space-between',
    flex: 3,
  },
});

export const SpinnerWrapper = styled.div({
  margin: '0 auto',
  position: 'absolute',
  top: '25%',
  left: '45%',
});

export const TickWrapper = styled.div({
  margin: '0 auto',
  position: 'absolute',
  top: '25%',
  left: '45%',
});

export const AppPreferenceContainer = styled.div({
  [mediaQuery('tablet')]: {
    display: 'none',
  },
});

export const AppPreferenceTitle = styled.div({
  textTransform: 'uppercase',
  color: '#686868',
  fontWeight: '600',
  fontSize: fontSize('s'),
  letterSpacing: '0.2px',
});

export const AppPreferenceDescription = styled.div({
  color: '#686868',
  fontSize: '13px',
  padding: '5px 40px 4px 0',
  opacity: '0.85',
  fontWeight: 'lighter',
});

export const ButtonContainer = styled.div({
  width: '100%',
  [mediaQuery('tablet')]: {
    textAlign: 'right',
    width: 'auto',
  },
});

export const MarketingPreferencesCheckboxes = styled.div({
  width: '100%',
});
